/* eslint-disable */
import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle, useEffect } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  // 下拉选项数据
  const [glChartNameOptions, setGlChartNameOptions] = useState([]);
  const [acctTypeOptions, setAcctTypeOptions] = useState([]);
  const [noPostOptions, setNoPostOptions] = useState([]);
  const [type1099Options, setType1099Options] = useState([]);
  const [glAcctSubTypeOptions, setGlAcctSubTypeOptions] = useState([]);

  // 加载下拉数据
  const loadOptions = async () => {
    try {
      const [glChartNameRes, acctTypeRes, noPostRes, type1099Res, subTypeRes] = await Promise.all([
        http.get(api.getFieldMapping, { params: { field: "gl_chart_name" } }),
        http.get(api.getFieldMapping, { params: { field: "acct_type" } }),
        http.get(api.getFieldMapping, { params: { field: "no_post" } }),
        http.get(api.getFieldMapping, { params: { field: "type1099" } }),
        http.get(api.getFieldMapping, { params: { field: "gl_acct_sub_type" } }),
      ]);

      setGlChartNameOptions((glChartNameRes.data || []).map(item => ({ value: item.value, label: item.label })));
      setAcctTypeOptions((acctTypeRes.data || []).map(item => ({ value: item.value, label: item.label })));
      setNoPostOptions((noPostRes.data || []).map(item => ({ value: item.value, label: item.label })));
      setType1099Options((type1099Res.data || []).map(item => ({ value: item.value, label: item.label })));
      setGlAcctSubTypeOptions((subTypeRes.data || []).map(item => ({ value: item.value, label: item.label })));
    } catch (error) {
      console.error("Failed to load options", error);
    }
  };

  // 打开弹窗时加载选项
  useEffect(() => {
    if (visible) {
      loadOptions();
    }
  }, [visible]);

  useImperativeHandle(ref, () => ({
    setModelAdd: () => {
      setEditRecord(null);
      form.resetFields();
      // 设置默认值
      form.setFieldsValue({
        glChartNameId: undefined,
        glAcct: "",
        glAcctLabel: "",
        title: "",
        acctType: undefined,
        noPost: "",
        type1099: "",
        remarks: "",
        glAcctSubTypeId: undefined,
      });
      setVisible(true);
    },
    setModelEdit: (record) => {
      setEditRecord(record);
      // 回填表单数据
      form.setFieldsValue({
        glChartNameId: record.glChartNameId,
        glAcct: record.glAcct,
        glAcctLabel: record.glAcctLabel,
        title: record.title,
        acctType: record.acctType,
        noPost: record.noPost ,
        type1099: record.type1099 ,
        remarks: record.remarks ,
        glAcctSubTypeId: record.glAcctSubTypeId,
      });
      setVisible(true);
    },
  }));

  const onFinish = async (values) => {
    setLoading(true);
    try {
      let response;
      const params = {
        glChartNameId: values.glChartNameId,
        glAcct: values.glAcct,
        // glAcctLabel: values.glAcctLabel,
        title: values.title,
        acctType: values.acctType,
        noPost: values.noPost ,
        type1099: values.type1099 ,
        remarks: values.remarks ,
        glAcctSubTypeId: values.glAcctSubTypeId,
      };

      if (editRecord) {
        // 编辑模式
        response = await http.post(api.getGLChartUpdate, {
          ...params,
          glChartId: editRecord.glChartId,
        });
      } else {
        // 新增模式
        response = await http.post(api.getGLChartAdd, params);
      }

      if (response?.code === "1") {
        message.success(editRecord ? "Updated Successfully" : "Added Successfully");
        setVisible(false);
        form.resetFields();
        setEditRecord(null);
        onSuccess && onSuccess();
      } else {
        message.error(response?.msg || (editRecord ? "Update failed" : "Add failed"));
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            {editRecord ? "EDIT GL CHART" : "ADD GL CHART"}
          </Typography.Title>
        </Flex>
      }
      width="40%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
        setEditRecord(null);
      }}
      maskClosable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              setVisible(false);
              form.resetFields();
              setEditRecord(null);
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
      }
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              form={form}
              name="createGLChartForm"
              layout="horizontal"
              labelCol={{ style: { width: "150px" } }}
              wrapperCol={{ style: { flex: 1 } }}
              onFinish={onFinish}
            >
              <Flex justify="space-between" align="flex-start">
                <div style={{ flex: 1 }}>
                  <Form.Item
                    name="glChartNameId"
                    label="Gl Chart Name"
                    rules={[{ required: true, message: "Please select Gl Chart Name" }]}
                  >
                    <Select
                      placeholder="Select Gl Chart Name"
                      options={glChartNameOptions}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>

                  <Form.Item
                    name="glAcct"
                    label="GL Account"
                    rules={[{ required: true, message: "Please enter GL Account" }]}
                  >
                    <Input placeholder="Please enter GL Account" allowClear />
                  </Form.Item>

                  <Form.Item
                    name="title"
                    label="Title"
                    rules={[{ required: true, message: "Please enter Title" }]}
                  >
                    <Input placeholder="Please enter Title" allowClear />
                  </Form.Item>

                  <Form.Item
                    name="acctType"
                    label="Account Type"
                    rules={[{ required: true, message: "Please select Account Type" }]}
                  >
                    <Select
                      placeholder="Select Account Type"
                      options={acctTypeOptions}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>
                   <Form.Item
                    name="glAcctSubTypeId"
                    label="GL Account Sub Type"
                 rules={[{ required: true, message: "GL Account Sub Type" }]}
                  >
                    <Select
                      placeholder="Select GL Account Sub Type"
                      options={glAcctSubTypeOptions}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>
                  <Form.Item
                    name="noPost"
                    label="No Post"
                    rules={[{ required: true, message: "Please select No Post" }]}
                  >
                    <Select
                      placeholder="Select NoPost"
                      options={noPostOptions}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>

                  <Form.Item
                    name="type1099"
                    label="Type 1099"
                    rules={[{ required: true, message: "Please select Type 1099" }]}
                  >
                    <Select
                      placeholder="Select Type 1099"
                      options={type1099Options}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>

                  <Form.Item
                    name="remarks"
                    label="Remarks"
                  >
                    <Input placeholder="Please enter remarks" allowClear />
                  </Form.Item>
                </div>
              </Flex>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default AddModal;